import styled from 'styled-components';

export const ContainerFoto = styled.div`
    display:flex;
    justify-content:center
`;

export const ContainerForm = styled.div`

`;

